import { Stack } from "@mui/material";
import BadgedAvatar from "../base/BadgedAvatar";
import { assertThumbnailUrl } from "../../redux/common";
import { UserInfo } from "../../redux/user/userSlice";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import { getOrRetrieveNamedObject, selectObjectCache } from "../../redux/object/objectCacheSlice";
import { useAppDispatch } from "../../app/hooks";
import { ObjectTarget } from "../../app/permissions";

interface UserTileProps {
    userId: number;
}

const UserTile = ({ userId }: UserTileProps) => {
    const objectCache = useSelector(selectObjectCache);
    const dispatch = useAppDispatch();
    const me = getOrRetrieveNamedObject(dispatch, objectCache, ObjectTarget.USER, `${userId}`);
    return (
        <Stack direction="column" spacing={0.5} flexWrap="wrap" sx={{my: 1}}>
            <Stack key={"user"} direction="row" alignItems="center">
                <BadgedAvatar
                    title={me?.display || "-"}
                    avatar={assertThumbnailUrl(me?.url)}
                    size="24px"
                    fontSize="12px"
                    marginRight={1}
                />
                {me?.display || "-"}
            </Stack>
        </Stack>
    );
};

export default UserTile;
